import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';

import { TpsServiceFactory, ITpsService } from './service';

TpsServiceFactory.initialize(useFloorplanDesignStore);

export {
  SHUTTLE_RACK,
  LASSIE_MINI_BOUNDS,
  LASSIE_BOUNDS,
  TEMPLATE_GENERATION_PREREQUISITES,
} from './constants';
export { isGroup, isLassie, isLassieMini, isShuttleRack, isHikStorage, isTemplate } from './guards';
export { TpsServiceFactory, type ITpsService };
export type { TemplateGenerationParams } from './types/typesCanvas';
